const VUE_APP_API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '';
const VUE_APP_IMAGES_BASE_URL = process.env.VUE_APP_IMAGES_BASE_URL || '';
const VUE_APP_STORE_ID = process.env.VUE_APP_STORE_ID || '';
const VUE_APP_GTM = process.env.VUE_APP_GTM || '';
const VUE_APP_HIDDEN_TOPICS = process.env.VUE_APP_HIDDEN_TOPICS || '';
const VUE_APP_TOPICS_SLIDER = process.env.VUE_APP_TOPICS_SLIDER || '';
const VUE_APP_HOME_SLIDER_FULL = process.env.VUE_APP_HOME_SLIDER_FULL || '';
const VUE_APP_STAGE = process.env.VUE_APP_STAGE || 'default';

export default {
  global: {
    storeId: VUE_APP_STORE_ID,
    apiBaseUrl: VUE_APP_API_BASE_URL,
    imageBaseUrl: VUE_APP_IMAGES_BASE_URL,
    hiddenTopics: VUE_APP_HIDDEN_TOPICS,
    topicsSlider: VUE_APP_TOPICS_SLIDER,
    homeSliderFull: VUE_APP_HOME_SLIDER_FULL,
    gtm: VUE_APP_GTM,
    stage: VUE_APP_STAGE,
  },
  page: {
    endpoints: {
      pages: `${VUE_APP_API_BASE_URL}/api/Topic/list`,
      page(url) {
        return `${VUE_APP_API_BASE_URL}/api/Topic/get?seName=${url}`;
      },
    },
  },
  core: {
    endpoints: {
      picture(id) {
        return `${VUE_APP_API_BASE_URL}/api/picture('${id}')`;
      },
      config: `${VUE_APP_API_BASE_URL}/api/config`,
      countries: `${VUE_APP_API_BASE_URL}/api/country`,
      stateProvince: `${VUE_APP_API_BASE_URL}/api/StateProvince/list`,
      warehouses: `${VUE_APP_API_BASE_URL}/api/Warehouse/list`,
      languages: `${VUE_APP_API_BASE_URL}/api/Language/list`,
      currencies: `${VUE_APP_API_BASE_URL}/api/Currency`,
      stores: `${VUE_APP_API_BASE_URL}/api/Store/list`,
      store: `${VUE_APP_API_BASE_URL}/api/Store/get`,
      slider(id) {
        return `${VUE_APP_API_BASE_URL}/api/slider?sliderType=${id}`;
      },
    },
  },
  checkout: {
    endpoints: {
      cart: `${VUE_APP_API_BASE_URL}/api/Level4/Cart`,
      simpleCart: `${VUE_APP_API_BASE_URL}/api/Level4/SimpleCart`,
      totals: `${VUE_APP_API_BASE_URL}/api/ShoppingCart/Totals`,
      addItem: `${VUE_APP_API_BASE_URL}/api/Level4/AddItem`,
      addItemsFromCsvCart: `${VUE_APP_API_BASE_URL}/api/Level4/cartFromCsv`,
      deleteItem: `${VUE_APP_API_BASE_URL}/api/ShoppingCart/DeleteItem`,
      updateItem: `${VUE_APP_API_BASE_URL}/api/ShoppingCart/UpdateItem`,
      clearCart: `${VUE_APP_API_BASE_URL}/api/ShoppingCart/ClearCart`,
      shippingAddress: `${VUE_APP_API_BASE_URL}/api/ShoppingCart/ShippingAddress`,
      confirmCheckout: `${VUE_APP_API_BASE_URL}/api/ShoppingCart/ConfirmCheckout`,
      shippingMethods(addressId) {
        return `${VUE_APP_API_BASE_URL}/api/ShoppingCart/ShippingMethods?addressId=${addressId}`;
      },
      paymentMethods(countryId) {
        return `${VUE_APP_API_BASE_URL}/api/ShoppingCart/PaymentMethods?countryId=${countryId}`;
      },
    },
  },
  user: {
    endpoints: {
      incadeaOrders: `${VUE_APP_API_BASE_URL}/api/level4Customer/incadeaOrders`,
      login: `${VUE_APP_API_BASE_URL}/api/user/login`,
      logout: `${VUE_APP_API_BASE_URL}/api/user/logout`,
      register: `${VUE_APP_API_BASE_URL}/api/Customer/register`,
      forgotPassword: `${VUE_APP_API_BASE_URL}/api/Customer/PasswordRecovery`,
      forgotPasswordConfirm: `${VUE_APP_API_BASE_URL}/api/Customer/PasswordRecoveryConfirm`,
      customer: `${VUE_APP_API_BASE_URL}/api/Customer/get`,
      customerUpdate: `${VUE_APP_API_BASE_URL}/api/Customer/Update`,
      setPassword: `${VUE_APP_API_BASE_URL}/api/Customer/SetPassword`,
      addAddress: `${VUE_APP_API_BASE_URL}/api/Customer/AddAddress`,
      updateAddress: `${VUE_APP_API_BASE_URL}/api/Customer/UpdateAddress`,
      deleteAddress: `${VUE_APP_API_BASE_URL}/api/Customer/DeleteAddress`,
      orders: `${VUE_APP_API_BASE_URL}/api/Order/List`,
      order(id) {
        return `${VUE_APP_API_BASE_URL}/api/Order/get?id=${id}`;
      },
      shoppingList: `${VUE_APP_API_BASE_URL}/api/ShoppingList`,
    },
  },
  level4: {
    endpoints: {
      categories: `${VUE_APP_API_BASE_URL}/api/Level4Category/List`,
      conditions: `${VUE_APP_API_BASE_URL}/api/Level4Product/VehicleConditions`,
      boards: `${VUE_APP_API_BASE_URL}/api/Level4Product/Boards`,
      board: `${VUE_APP_API_BASE_URL}/api/Level4Product/Board`,
      find: `${VUE_APP_API_BASE_URL}/api/Level4Product/Find`,
      vin(vin) {
        return `${VUE_APP_API_BASE_URL}/api/level4/Vehicle?vin=${vin}`;
      },
      stock: `${VUE_APP_API_BASE_URL}/api/level4/ProductStock`,
      creditLimit: `${VUE_APP_API_BASE_URL}/api/Level4Customer/CreditLimit`,
      vehicleFilter(type) {
        return `${VUE_APP_API_BASE_URL}/api/level4/VehicleFilter?type=${type}`;
      },
      hotspots(id) {
        return `${VUE_APP_API_BASE_URL}/api/level4Product/Hotspots?grafikId=${id}`;
      },
      vehicleSearch: `${VUE_APP_API_BASE_URL}/api/Level4/VehicleSearch`,
    },
  },
  catalog: {
    endpoints: {
      product(id) {
        return `${VUE_APP_API_BASE_URL}/api/Product('${id}')`;
      },
      category(id) {
        return `${VUE_APP_API_BASE_URL}/api/Category('${id}')`;
      },
    },
  },
};
